import type {
  CredentialMetadata,
  DataResponse,
  ExtensionAddSkill,
  ExtensionCreate,
  ExtensionProfileCreate,
  ExtensionProfileResponse,
  ExtensionProfileUpdate,
  ExtensionResponse,
  ExtensionSummary,
  ExtensionUpdate,
  TeamAccessResponse,
} from "@/types";
import { api } from "../api";

export const extensionService = {
  list: () => api.get<DataResponse<ExtensionSummary[]>>("/extensions"),

  get: (uuid: string) => api.get<DataResponse<ExtensionResponse>>(`/extensions/${uuid}`),

  update: (uuid: string, data: ExtensionUpdate) =>
    api.put<DataResponse<ExtensionResponse>>(`/extensions/${uuid}`, data),

  toggle: (uuid: string, isEnabled: boolean) =>
    api.patch<DataResponse<ExtensionResponse>>(`/extensions/${uuid}/toggle`, { isEnabled }),

  getCredentials: (uuid: string) => api.get<DataResponse<CredentialMetadata[]>>(`/extensions/${uuid}/credentials`),

  setCredential: (uuid: string, data: { key: string; value: string }) =>
    api.put<DataResponse<CredentialMetadata[]>>(`/extensions/${uuid}/credentials`, data),

  clearCredential: (uuid: string, key: string) =>
    api.delete<DataResponse<CredentialMetadata[]>>(`/extensions/${uuid}/credentials/${encodeURIComponent(key)}`),

  getTeamAccess: (uuid: string) => api.get<DataResponse<TeamAccessResponse[]>>(`/extensions/${uuid}/team-access`),

  setTeamAccess: (uuid: string, teamUuids: string[]) =>
    api.put<DataResponse<TeamAccessResponse[]>>(`/extensions/${uuid}/team-access`, { teamUuids }),

  create: (data: ExtensionCreate) => api.post<DataResponse<ExtensionResponse>>("/extensions", data),

  addSkill: (uuid: string, data: ExtensionAddSkill) =>
    api.post<DataResponse<ExtensionResponse>>(`/extensions/${uuid}/skills`, data),

  delete: (uuid: string) => api.delete(`/extensions/${uuid}`),

  // Profiles
  listProfiles: (uuid: string) => api.get<DataResponse<ExtensionProfileResponse[]>>(`/extensions/${uuid}/profiles`),

  createProfile: (uuid: string, data: ExtensionProfileCreate) =>
    api.post<DataResponse<ExtensionProfileResponse>>(`/extensions/${uuid}/profiles`, data),

  updateProfile: (extUuid: string, profileUuid: string, data: ExtensionProfileUpdate) =>
    api.put<DataResponse<ExtensionProfileResponse>>(`/extensions/${extUuid}/profiles/${profileUuid}`, data),

  deleteProfile: (extUuid: string, profileUuid: string) => api.delete(`/extensions/${extUuid}/profiles/${profileUuid}`),
};
